import Cookies from 'js-cookie';


export const SHOW_SUCCESS_PAGE:string = "show_success_page"
export const EC_CRSF_TOKEN = "ec_csrf"


export function setCRSFToken(id: string): void {
    Cookies.set(EC_CRSF_TOKEN, id, {
        // expires: 1,
        // path: '/',
    });
}


export function getCRSFToken():string | undefined {
    return Cookies.get(EC_CRSF_TOKEN) ? Cookies.get(EC_CRSF_TOKEN) : "";
}


export function deleteCRSFToken(): void {
    Cookies.remove(EC_CRSF_TOKEN);
}


export function setCookie24h(name: string, value: string) {
    const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
    document.cookie =
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}; ` +
        `expires=${expires}; path=/; SameSite=Lax`;
}

export function getCookie(name: string): string | null {
    const key = encodeURIComponent(name) + "=";
    const parts = document.cookie.split("; ");
    for (const p of parts) {
        if (p.startsWith(key)) {
            return decodeURIComponent(p.substring(key.length));
        }
    }
    return null;
}